export class JsonStringConverter {
    serialize(property) {
        return property;
    }
    deserialize(value) {
        return value;
    }
    // not ignored here for istanbul, because it should be used if 'true'
    collapseArrayWithSingleItem() {
        return true;
    }
}
//# sourceMappingURL=string-converter.js.map